const fbLinkWhiteSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="21.201px" height="21.201px" viewBox="0 0 21.201 21.201" enable-background="new 0 0 21.201 21.201" xml:space="preserve">
<g id="Layer_1">
	<g>
		<g>
			<path fill="#FFFFFF" d="M18.717,0H2.484C1.115,0,0,1.114,0,2.484v16.232c0,1.37,1.115,2.484,2.484,2.484h16.232
				c1.37,0,2.484-1.114,2.484-2.484V2.484C21.201,1.114,20.086,0,18.717,0z M19.545,18.717c0,0.457-0.372,0.828-0.828,0.828h-4.721
				v-6.75h2.559l0.423-2.567h-2.981V8.448c0-0.704,0.539-1.244,1.242-1.244h1.698V4.638h-1.698c-2.108,0-3.809,1.708-3.809,3.816
				v1.773H8.944v2.567h2.485v6.75H2.484c-0.457,0-0.829-0.371-0.829-0.828V2.484c0-0.456,0.373-0.828,0.829-0.828h16.232
				c0.457,0,0.828,0.372,0.828,0.828V18.717z"/>
		</g>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>

`;

export default fbLinkWhiteSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/fbLinkWhiteSVG.js